<template>
	<div class="reissue-drawer">
		<el-drawer :visible.sync="drawer" title="补寄样品申请" size="760px" :before-close="handleClose" destroy-on-close>
			<div class="drawer-wrap">
				<div class="content">
					<!-- <Tip class="mb-8"> 开播后补寄样品的样品订单，请在“样品管理”中查看 </Tip> -->
					<div class="label flex flex-just-between flex-align-center">商品信息</div>
					<div class="card-box">
						<product-box class="product-content" :row="row" :tabName="tabName"></product-box>
					</div>
					<div class="label flex flex-just-between flex-align-center mt-16">达人信息</div>
					<div class="card-box mt-8">
						<user-info-box class="user-info-content" :row="row"></user-info-box>
					</div>
					<div class="label flex flex-just-between flex-align-center mt-16 mb-2">申样规格</div>
					<div class="mb-24 pl-16">
						<Tip v-if="!hasSku" class="mt-12 mb-6"> 暂未获取到部分商品的规格，您可将申样要求填写在该商品对应的备注中 </Tip>
						<sample-specs
							class="flex-1"
							:productId="row.product_id"
							:platformId="row.platform_id"
							@change="getSkuChange"
							ref="sampleSpecs"
							:isShow="true"
							:list="skuList"
						></sample-specs>
					</div>
					<el-form style="margin-top: 32px" :model="form" :rules="rules" ref="ruleForm" label-width="82px">
						<el-form-item label="申样备注">
							<el-input
								type="textarea"
								:rows="3"
								placeholder="请输入申样备注，如规格等"
								v-model="form.buyer_remark"
								maxlength="100"
								show-word-limit
							/>
						</el-form-item>
						<div class="label flex flex-just-between flex-align-center">
							<p>收货地址</p>
							<p @click="autoDiscern" class="auto yx-color-primary pointer">
								<i class="el-icon-edit"></i>
								<span class="ml-6">智能识别地址</span>
							</p>
						</div>
						<el-form-item label="收件人" prop="delivery_name">
							<el-input type="text" placeholder="请输入收件人" v-model="form.delivery_name" maxlength="10" show-word-limit />
						</el-form-item>
						<el-form-item label="手机号" prop="delivery_mobile">
							<el-input type="text" placeholder="请输入手机号" v-model="form.delivery_mobile" maxlength="11" />
						</el-form-item>
						<el-form-item label="所在区域" prop="province">
							<el-cascader class="width100" v-if="drawer" @change="selecteFun" :options="AreaTree" clearable v-model="selectedOptions"> </el-cascader>
						</el-form-item>
						<el-form-item label="详细地址" prop="delivery_addr">
							<el-input type="textarea" :rows="3" placeholder="请输入详细地址" v-model="form.delivery_addr" maxlength="60" show-word-limit />
						</el-form-item>
					</el-form>
				</div>
				<div class="bottom-btn">
					<el-button @click="handleClose">取 消</el-button>
					<el-button type="primary" @click="submit" :loading="submitLoading">确 认</el-button>
				</div>
			</div>
		</el-drawer>
		<auto-address @returnValue="returnValue" ref="autoAddress"></auto-address>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import area from '@/utils/area/index';
import autoAddress from '@/views/common/autoAddress';
import { reissueSample, cooperationGetAddress } from '@/api/cooperationProgress';
import { deepClone } from '@/utils/common';
import sampleSpecs from '@/components/business/sampleSpecs';
import { getProductSkuList, syncProductSkuList } from '@/api/shopManage';
export default {
	name: 'reissueDrawer',
	props: {
		tabName: {
			type: String,
			default: '',
		},
	},
	components: {
		productBox,
		userInfoBox,
		autoAddress,
		sampleSpecs,
	},
	data() {
		return {
			drawer: false,
			row: {},
			selectedOptions: [],
			AreaTree: area.AreaTree,
			CodeToText: area.CodeToText,
			TextToCode: area.TextToCode,
			form: {
				cooperate_id: '',
				buyer_remark: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
			},
			rules: {
				delivery_name: { required: true, message: '请输入收件人', trigger: 'blur' },
				delivery_mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
				province: { required: true, message: '请选择所在区域', trigger: 'change' },
				delivery_addr: { required: true, message: '请输入详细地址', trigger: 'blur' },
			},
			submitLoading: false,
			skuList: [],
			applySku: [],
			hasSku: true,
		};
	},
	methods: {
		async show(row) {
			this.row = row;
			this.form.cooperate_id = row.cooperate_id;
			await this.asyncSkuList();
			this.getSkuList();
			this.getAddress();
			this.drawer = true;
		},
		handleClose() {
			this.row = {};
			this.selectedOptions = [];
			this.hasSku = true;
			this.form = {
				cooperate_id: '',
				buyer_remark: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
			};
			// 关闭弹窗
			this.applySku = [];
			this.skuList = [];
			this.specification_remark = '';
			this.$refs.ruleForm.resetFields();
			this.drawer = false;
		},
		selecteFun(e) {
			const code = e[2];
			const [province, city, area] = this.CodeToText(this.selectedOptions);
			this.form.province = province;
			this.form.city = city;
			this.form.area = area;
			this.form.code = code;
		},
		returnValue(e) {
			for (let key in e) {
				this.form[key] = e[key];
			}
			let [province, city, area] = this.TextToCode([e.province, e.city, e.area]);
			if (!area) {
				this.form['delivery_addr'] = e.province + e.city + e.area + e.delivery_addr;
				this.$set(this.rules, 'province', { required: false, message: '请选择区域', trigger: 'change' });
			} else {
				this.$set(this.rules, 'province', { required: true, message: '请选择区域', trigger: 'change' });
			}
			this.selectedOptions = [province, city, e.code];
			this.form.code = this.selectedOptions[2];
		},
		autoDiscern() {
			this.$refs.autoAddress.show();
		},
		submit: debounce(function () {
			let obj = deepClone(this.form, 'downLine');
			let sku = this.hasSku ? this.applySku : undefined;
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				try {
					this.submitLoading = true;
					const { code } = await reissueSample({ ...obj, specification_remark: this.specification_remark, sku });
					if (code !== 0) return;
					this.$message.success('补寄样品申请成功');
					this.$emit('getList');
					this.handleClose();
				} finally {
					this.submitLoading = false;
				}
			});
		}, 300),
		async getSkuList() {
			const { product_id, platform_id } = this.row;
			const data = await getProductSkuList({ productIds: [product_id], platformId: platform_id });
			this.hasSku = !!data.length;
			this.skuList = [{ hasSku: this.hasSku, price: '', num: '' }];
		},
		getSkuChange(val, specification_remark) {
			this.applySku = val.map(item => {
				return {
					price: item.spuPrice,
					specification: item.specification,
					outerSkuId: item.skuId,
					num: item.num,
				};
			});
			this.specification_remark = specification_remark;
		},
		async getAddress() {
			if (!this.row.sample_sn) {
				return;
			}
			const delivery_address = await cooperationGetAddress({
				sampleSn: this.row.sample_sn,
				contactId: this.row.contact_id,
			});
			Object.keys(delivery_address).forEach(key => (this.form[key] = delivery_address[key]));
			let [province, city] = this.TextToCode([delivery_address.province, delivery_address.city, delivery_address.area]);
			this.selectedOptions = [province, city, delivery_address.code];
			this.form.code = this.selectedOptions[2];
		},

		async asyncSkuList() {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			const { platform_id, product_id, third_product_id } = this.row;

			await syncProductSkuList({
				platformId: platform_id,
				productIds: [
					{
						outProductId: third_product_id,
						productId: product_id,
					},
				],
				source: dataMap.syncSkuSource.reshipment,
			});
		},
	},
};
</script>

<style lang="less" scoped>
.reissue-drawer {
	.drawer-wrap {
		background: #fff;
		height: 100%;
		overflow: hidden;
		padding-bottom: 61px;
		.content {
			height: 100%;
			position: relative;
			overflow-y: auto;
			padding: 24px;
			box-sizing: border-box;
			.tip {
				padding: 16px;
				border-radius: 2px;
				box-sizing: border-box;
				border: 1px solid @color-primary;
				background-color: #e9f1ff;
				margin-bottom: 16px;
			}
			.card-box {
				border-radius: 8px;
				// background-color: #f6f5fc;
				background-color: #f7f8fa;
				padding: 12px;
				width: 336px;
				.user-info-content,
				.product-content {
					background-color: #fff;
					border-radius: 8px;
					padding: 8px;
				}
				.user-info-content {
				}
			}
			.label {
				font-size: 14px;
				color: #333;
				font-weight: 700;
				margin-bottom: 16px;
				.auto {
					font-weight: normal;
				}
			}
		}
	}
	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
}
</style>
